import { constantRouters, lastRouters, asyncRouters } from '@/router/index'
// import { getResourceVo, checkUserStatus } from '@/api/user'
// import { getRegionListByAuth } from '@/api/merchants'
import store from '@/store'
import { SYSTEM_ID } from '@/config'
import { SPECIAL_AUTH_ID, AUTH_SWITCH } from '@/config/auth'
const MENU = '1' // 资源類型-菜單
let routerMap = new Map()
let specialAuth = []

function traversalAuthTree (authTree) {
  if (authTree.menuId || authTree.systemId) {
    if (authTree.menuId && SPECIAL_AUTH_ID.includes(authTree.menuId)) {
      specialAuth.push(authTree.menuId)
    }
    if (authTree.type === MENU) {
      pushDataInRouterMap(authTree)
    }
  }
  if (authTree.menuList) {
    authTree.menuList.forEach(node => {
      traversalAuthTree(node)
    })
  }
}

function pushDataInRouterMap (node) {
  if (!routerMap.has(node.menuId)) {
    const childId = node.menuList.map(child => { return child.menuId })
    routerMap.set(node.menuId, childId)
  }
}

function generateAuthAsyncRouters () {
  asyncRouters.forEach(router => {
    traversalAsyncRouters(router)
  })
}

function traversalAsyncRouters (router) {
  if (routerMap.has(router.meta.resId)) {
    router.meta.authOwn = routerMap.get(router.meta.resId)
  }
  if (router.children) {
    for (let index = 0; router.children && index < router.children.length; index++) {
      if (routerMap.has(router.meta.resId) &&
                routerMap.get(router.meta.resId).includes(router.children[index].meta.resId)) {
        if (!router.redirect) {
          router.redirect = router.path + '/' + router.children[index].path
        }
        traversalAsyncRouters(router.children[index])
      } else if (!specialAuth.includes(router.children[index].meta.resId)) {
        router.children.splice(index--, 1)
      }
      if (router.children.length === 0) {
        delete router.children
      }
    }
  }
}

const router = {
  state: {
    routers: constantRouters,
    routersAdd: [],
    authFinish: false,
    currentPageAuth: [],
    specialAuth: [],
    citys: [],
    cityOptions: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.routersAdd = routers
      state.routers = constantRouters.concat(routers)
    },
    SET_AUTH_FINISH: state => {
      state.authFinish = true
    },
    SET_CURRENT_PAGE_AUTH: (state, authList) => {
      state.currentPageAuth = authList
    },
    SET_SPECIAL_AUTH: (state, authList) => {
      state.specialAuth = authList
    },
    SET_city: (state, city) => {
      state.citys = city
      localStorage.city = JSON.stringify(city)
    },
    SET_CITY_OPTIONS: (state, options) => {
      state.cityOptions = options
    }
  },
  actions: {
    generateRoutes ({ commit }) {
      return new Promise((resolve, reject) => {
        if (AUTH_SWITCH) {
          getResourceVo({ params: { systemId: SYSTEM_ID } }).then(res => {
            if (res.data && res.data[0]) {
              traversalAuthTree(res.data[0])
              generateAuthAsyncRouters()
              commit('SET_AUTH_FINISH')
              const routersAdd = [...asyncRouters, ...lastRouters]
              commit('SET_SPECIAL_AUTH', specialAuth)
              commit('SET_ROUTERS', routersAdd)
              resolve()
            } else {
              checkUserStatus().then(res => {
                if (!res || res.code != 200) {
                  store.dispatch('LogOut').then(() => {
                    location.reload()
                  })
                } else {
                  const routersAdd = [...lastRouters]
                  commit('SET_ROUTERS', routersAdd)
                  resolve()
                }
                commit('SET_AUTH_FINISH')
              })
            }
          })
        } else {
          commit('SET_AUTH_FINISH')
          const routersAdd = [...asyncRouters, ...lastRouters]
          commit('SET_ROUTERS', routersAdd)
          resolve(routersAdd)
        }
      })
    },
    setCurrentPageAuth ({ commit }, routerTo) {
      if (routerTo.meta) {
        commit('SET_CURRENT_PAGE_AUTH', routerTo.meta.authOwn || [])
      } else {
        commit('SET_CURRENT_PAGE_AUTH', [])
      }
    },
    getUserInfo ({ commit, state }) {
      getRegionListByAuth({
        params: {
          loginUserId: localStorage.loginId
        }
      }).then(res => {
        const rescity = res.map(item => {
          return {
            children: item.children,
            id: item.id,
            label: item.label,
            namePath: item.namePath,
            path: item.path,
            value: item.value + '-'
          }
        })
        commit('SET_city', rescity)
        commit('SET_CITY_OPTIONS', res)
      })
    }
  }
}

export default router
